import gql from 'graphql-tag'
import React from 'react'
import {
  ChartContainer,
  ChartDataLoader,
  ChartHeading,
  ChartTable,
} from 'admin-web-ui'
import { useQuery } from '@apollo/client'

export const GET_VOICE_CALLING_DURATION = gql`
  query {
    reports {
      voiceCallingDuration
    }
  }
`

export const CallDurationChart: React.FC = () => {
  const dataResult = useQuery(GET_VOICE_CALLING_DURATION)

  return (
    <ChartContainer>
      <ChartHeading
        heading="Call Duration"
        subHeading="Collected over the last 60 days."
      />
      <ChartDataLoader
        dataResult={dataResult}
        dataPath="reports.voiceCallingDuration"
      >
        {(chartData) => (
          <ChartTable
            tableProps={{
              showHeader: false,
            }}
            chartData={chartData}
            columnProps={{
              source: {
                title: 'Source',
              },
              value: {
                title: 'Value',
                align: 'right',
              },
            }}
          />
        )}
      </ChartDataLoader>
    </ChartContainer>
  )
}
